<div style="width:100%;position:relative;display:flex;flex-direction:column;align-items:center;">
    <i (click)="close()" class="mdi mdi-close cursor-pointer" style="top:8px;right:8px;position:absolute;z-index:1;color:#fff;" ></i>
    <img *ngIf="image!=null" style="max-width: 100%;" [src]="image" alt="">
</div>